export const FormField = ({ field, value, onChange, error }) => {
  const testId = `intake-field-${field.name}`;
  const base = "w-full border border-gray-300 rounded-md p-3 bg-white text-dark-text focus:ring-2 focus:ring-magenta focus:border-transparent outline-none transition-shadow";

  const label = (
    <label className="block text-sm font-semibold text-navy mb-1.5">
      {field.label}{field.required && <span className="text-magenta"> *</span>}
    </label>
  );

  let control;
  if (field.type === "textarea") {
    control = (
      <textarea data-testid={testId} rows={3} className={base}
        value={value || ""} placeholder='Enter "None" if not applicable'
        onChange={(e) => onChange(field.name, e.target.value)} />
    );
  } else if (field.type === "select") {
    control = (
      <select data-testid={testId} className={base} value={value || ""}
        onChange={(e) => onChange(field.name, e.target.value)}>
        <option value="">Select…</option>
        {field.options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  } else if (field.type === "radio") {
    control = (
      <div className="flex gap-2" data-testid={testId}>
        {field.options.map((o) => (
          <button type="button" key={o}
            data-testid={`${testId}-${o.toLowerCase()}`}
            onClick={() => onChange(field.name, o)}
            className={`flex-1 py-2.5 px-4 rounded-md text-sm font-semibold border transition-colors ${
              value === o ? "bg-magenta text-white border-magenta" : "bg-white text-navy border-gray-300 hover:border-magenta"
            }`}>
            {o}
          </button>
        ))}
      </div>
    );
  } else {
    control = (
      <input data-testid={testId} type={field.type} className={base}
        value={value || ""} placeholder={field.placeholder}
        onChange={(e) => onChange(field.name, e.target.value)} />
    );
  }

  return (
    <div className={field.half ? "sm:col-span-1" : "sm:col-span-2"}>
      {label}
      {control}
      {error && <p className="text-xs text-red-600 mt-1" data-testid={`${testId}-error`}>{error}</p>}
    </div>
  );
};
